import { createContext } from 'react';
export var BILoggerContext = createContext({});
//# sourceMappingURL=BILoggerContext.js.map